/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React, {MouseEventHandler} from 'react';
import {IconButton} from '../../components/buttons/IconButton';
import {ExitFullScreenIcon} from '../../icons/ExitFullScreenIcon';
import {FullScreenIcon} from '../../icons/FullScreenIcon';
import {IconSize} from '../../types/types';

export interface FullScreenProps {
  size?: IconSize | number;
  fullScreen: boolean;
  handleClickFullscreen: MouseEventHandler<HTMLButtonElement>;
}

/**
 * @FullScreen
 *
 * Defines the FullScreen Component. Materail UI is used for maximizing the dialog
 *
 * ```typescript
 * import FullScreen from '@ion/dls/src/components/videoplayer/FullScreen';
 *
 * const [fullScreen, setFullScreen] = useState(false);
 *  function handleClickFullscreen() {
 *   setFullScreen(!fullScreen);
 * }
 *
 * <FullScreen fullScreen={fullScreen}
 *    handleClickFullscreen={handleClickFullscreen} />
 *
 * ```
*/
const FullScreen = ({
  size = IconSize.medium,
  fullScreen,
  handleClickFullscreen
}: FullScreenProps) => {
  return (
    <>
      <IconButton onClick={handleClickFullscreen}
        icon={
          fullScreen
            ? <ExitFullScreenIcon size={size} />
            : <FullScreenIcon size={size} />
        } />
    </>
  );
};

export default FullScreen;
